import { render } from "./ServicioCreate.vue?vue&type=template&id=c8175414&scoped=true"
import script from "./ServicioCreate.vue?vue&type=script&lang=js"
export * from "./ServicioCreate.vue?vue&type=script&lang=js"

import "./ServicioCreate.vue?vue&type=style&index=0&id=c8175414&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\clogistica_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8175414"]])

export default __exports__